export default "__VITE_ASSET__DsiUZcQh__"